/**
 * Underline skin for a date/time picker trigger under the "underlined" control
 * presentation. Mirrors TextInput's underline — 1px resting, thickening to 2px
 * brand on hover/open (the padding shifts to absorb the extra pixel so the
 * trigger doesn't jump), red on error — so the pickers sit alongside underlined
 * inputs in the spacious customer flows. The picker still opens its popover;
 * only the resting trigger skin changes.
 */
export function dateTriggerUnderline(args: {
  isError?: boolean;
  open?: boolean;
  disabled?: boolean;
  compact?: boolean;
}): string {
  const {
    isError = false,
    open = false,
    disabled = false,
    compact = false,
  } = args;
  const border = isError
    ? "border-b-2 border-red pb-1"
    : open
      ? "border-b-2 border-brand pb-1"
      : "border-b border-muted-foreground pb-[5px] hover:border-b-2 hover:border-brand hover:pb-1";
  return `group inline-flex cursor-pointer items-center gap-2 bg-transparent transition-colors ${compact ? "pt-1" : "pt-2"} ${border} ${disabled ? "pointer-events-none opacity-40" : ""}`;
}

/** The value-text classes for an underlined trigger (the bold Cargo value). */
export function dateTriggerText(hasValue: boolean, compact = false): string {
  return `${compact ? "text-sm" : "text-xl"} font-bold ${hasValue ? "text-foreground" : "text-faint"}`;
}
